import { addDoc, deleteDoc, doc, getFirestore, onSnapshot, setDoc } from 'firebase/firestore';
import { getStorage, ref, uploadBytes } from 'firebase/storage';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { currentUser } from '../../util/currentUser';
import { app } from '../../util/firebase';

const UpdateMedoc = (props) => {
    
    const [name,setName] = useState("")
    const [price,setPrice] = useState("")
    const [stock,setStock] = useState(0)
    const [img,setImg] = useState(null)
    const [isChecked,setIsChecked] = useState(false)

    const [currentMedoc,setCurrentMedoc] = useState()
    const navigate = useNavigate()
    
    useEffect(()=>{
        onSnapshot(doc(getFirestore(app),"medocs",props.medocID),snap=>{
            setCurrentMedoc(()=>{
                let medoc = snap.data()
                setName(medoc.name)
                setPrice(medoc.price)
                setStock(medoc.stock)
                setIsChecked(true)

                return medoc
            })
        })
    },[])

    const update =(e)=>{
        e.preventDefault()
        let medoc = currentMedoc
        medoc.name = name
        medoc.price = price
        medoc.stock = stock

        if(isChecked){
            setDoc(doc(getFirestore(app),"medocs",props.medocID),medoc)
            .then(()=>{
                alert('Le médicament a été mis a jours')
                navigate(-1)
            })
            .catch(err=>alert(err))
        }else{
            let imgUrl = medoc.imgSrc.substring(72,medoc.imgSrc.length -10)
            imgUrl = imgUrl.replaceAll("%2F","/")

            let storageRef = ref(getStorage(app),imgUrl)
            uploadBytes(storageRef,img)
            .then(result=>{
                
                setDoc(doc(getFirestore(app),"medocs",props.medocID),medoc)
                .then(()=>{
                    alert('Le médicament a été mis a jours')
                    navigate(-1)
                })
                .catch(err=>alert(err))
            })
            .catch(err=>alert(err))
        }
    }
    return (
        <div style={{minHeight:'80vh'}}>
            <div className='col-12 col-md-5 m-auto shadow p-3 my-3 '>
                <form onSubmit={e=>update(e)}>
                    <input required className='form-control my-3' type="text" placeholder='Nom du médicament' value={name} onChange={e=>setName(e.target.value)}></input>
                    <input required className='form-control my-3' type="number" placeholder='prix de médicament' value={price} onChange={e=>setPrice(e.target.value)}></input>
                    <input required className='form-control my-3' type="number" placeholder='Quantité en stock' value={stock} onChange={e=>setStock(parseInt(e.target.value))}></input>
                    
                    <div className='row'>
                        <div className='col-8'>
                            <label>
                                <input className='my-3' checked={isChecked} type="checkbox" onChange={e=>setIsChecked(!isChecked)}></input>
                                Garder l'image actuel
                            </label>
                        </div>
                        <div className='col-4'>  
                            {isChecked?(                        
                                <div className='col-12' style={{minHeight:'115px',backgroundImage:'url('+currentMedoc.imgSrc+')',backgroundPosition:'center',backgroundSize:'cover',backgroundRepeat:'no-repeat'}}></div>
                            ):(null)}
                        </div>
                    </div>
                    {isChecked?(null):(
                        <input required className='form-control my-3' type="file" onChange={e=>setImg(e.target.files[0])}></input>
                    )}
                    <button className='btn btn-primary col-12'>Mettre a jour le médicament</button>
                </form>
            </div>
        </div>
    );
};

export default UpdateMedoc;